import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { HttpClientModule } from '@angular/common/http';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { Geolocation } from '@ionic-native/geolocation';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { LocalNotifications } from '@ionic-native/local-notifications';
import { HeaderColor } from '@ionic-native/header-color';
// import { Firebase } from '@ionic-native/firebase';
// import { AngularFireModule } from 'angularfire2';
// import { AngularFirestoreModule } from 'angularfire2/firestore';

const firebase = {
 // your firebase web config
}

//PAGES
import { MyApp } from './app.component';
import { WelcomePage } from '../pages/welcome/welcome';
import { LoginPage } from '../pages/login/login';
import { JanelaPage } from '../pages/janela/janela';
import { ChangepassPage } from '../pages/changepass/changepass';
import { ForgotPage } from '../pages/forgot/forgot';

//ADIANTADOR
import { AdiantadorPedidosPage } from '../pages/adiantador-pedidos/adiantador-pedidos';
import { AdiantadorOperacaoPage } from '../pages/adiantador-operacao/adiantador-operacao';


//OPERADOR
import { OperadorPedidosPage } from '../pages/operador-pedidos/operador-pedidos';
import { OperadorInfopedidoPage } from '../pages/operador-infopedido/operador-infopedido';
import { OperadorInfoprodutoPage } from '../pages/operador-infoproduto/operador-infoproduto';
import { OperadorOperacaoPage } from '../pages/operador-operacao/operador-operacao';
import { OperadorCaixasPage } from '../pages/operador-caixas/operador-caixas';
import { OperadorPackingPage } from '../pages/operador-packing/operador-packing';


//GESTOR
import { ListaGestorPage } from '../pages/listaGestor/listaGestor';
import { PedidoGestorPage } from '../pages/pedidoGestor/pedidoGestor';

//MOTORISTA
import { ListaPage } from '../pages/lista/lista';
import { PedidoPage } from '../pages/pedido/pedido';
import { EntregasPage } from '../pages/entregas/entregas';
import { ViewEntregaPage } from '../pages/view-entrega/view-entrega';
import { ConferenciaPage } from '../pages/conferencia/conferencia';

//PROVIDERS
import { Api, Tools, User, Services, SyncIO, Tracking } from '../providers';

import { IonicStorageModule } from '@ionic/storage';
import { FcmProvider } from '../providers/fcm/fcm';

@NgModule({
  declarations: [
    MyApp,
    WelcomePage,
    LoginPage,
    JanelaPage,
    ListaPage,
    ListaGestorPage,
    PedidoPage,
    PedidoGestorPage,
    EntregasPage,
    ViewEntregaPage,
    ConferenciaPage,
    ChangepassPage,
    ForgotPage,
    AdiantadorPedidosPage,
    AdiantadorOperacaoPage,
    OperadorPedidosPage,
    OperadorInfopedidoPage,
    OperadorInfoprodutoPage,
    OperadorOperacaoPage,
    OperadorCaixasPage,
    OperadorPackingPage
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot(),
    // AngularFireModule.initializeApp(firebase),
    // AngularFirestoreModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    WelcomePage,
    LoginPage,
    JanelaPage,
    ListaPage,
    ListaGestorPage,
    PedidoPage,
    PedidoGestorPage,
    EntregasPage,
    ViewEntregaPage,
    ConferenciaPage,
    ChangepassPage,
    ForgotPage,
    AdiantadorPedidosPage,
    AdiantadorOperacaoPage,
    OperadorPedidosPage,
    OperadorInfopedidoPage,
    OperadorInfoprodutoPage,
    OperadorOperacaoPage,
    OperadorCaixasPage,
    OperadorPackingPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    Api,
    Tools,
    User,
    Services,
    SyncIO,
    Tracking,
    BarcodeScanner,
    Geolocation,
    Camera,
    LocalNotifications,
    // Firebase,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    HeaderColor,
    FcmProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts